'use strict';

export default angular
  .module('maestro.filters.timezoneGmt', [])

  /**
   * Format timezone in format like "Asia/Colombo GMT+05:30"
   */
  .filter('timezoneGmt', function() {
    return function(timezoneId) {
      if (!timezoneId || !moment.tz.zone(timezoneId)) {
        return 'Greenwich Mean Time (GMT)';
      }
      let offsetFormatted = moment.tz(timezoneId).format('Z'); // Format like +05:30
      return `${timezoneId} GMT${offsetFormatted}`;
    };
  })

  .name;
